import {
  ApdmCampaignKind,
  ApdmCampaignPreviewWarning,
  ApdmCampaignStatus,
  ApdmContactBlockReason,
} from '@euler/model/apdm';

export const kApdmCampaignKindLabels: Record<ApdmCampaignKind, string> = {
  [ApdmCampaignKind.WinBack]: '唤回客户',
  [ApdmCampaignKind.MaintenanceDue]: '保养提醒',
  [ApdmCampaignKind.Promotion]: '优惠活动',
  [ApdmCampaignKind.Greeting]: '节日问候',
};

export const kApdmCampaignStatusLabels: Record<ApdmCampaignStatus, string> = {
  [ApdmCampaignStatus.Draft]: '待启动',
  [ApdmCampaignStatus.Scheduled]: '已排期',
  [ApdmCampaignStatus.Reaching]: '发送中',
  [ApdmCampaignStatus.Paused]: '已暂停',
  [ApdmCampaignStatus.Reached]: '已触达',
  [ApdmCampaignStatus.Ended]: '已结束',
};

export const kApdmPreviewWarningLabels: Record<
  ApdmCampaignPreviewWarning,
  string
> = {
  [ApdmCampaignPreviewWarning.StartRequired]: '请填写开始时间。',
  [ApdmCampaignPreviewWarning.WindowExpired]: '发送时间窗口已过期。',
  [ApdmCampaignPreviewWarning.NoLiveAccounts]: '当前没有在线发送账号。',
  [ApdmCampaignPreviewWarning.AccountsThrottled]: '部分账号正在限流。',
  [ApdmCampaignPreviewWarning.SustainableRateUnknown]:
    '持续发送速率未知，不能保证完成时间。',
  [ApdmCampaignPreviewWarning.InsufficientWindow]: '当前发送窗口可能不足。',
};

export const kApdmBlockReasonLabels: Record<ApdmContactBlockReason, string> = {
  [ApdmContactBlockReason.CampaignInactive]: '活动未运行',
  [ApdmContactBlockReason.OutsideWindow]: '不在发送窗口',
  [ApdmContactBlockReason.DoNotContact]: '客户拒绝联系',
  [ApdmContactBlockReason.Cooldown]: '冷却期内',
  [ApdmContactBlockReason.OpenOrder]: '有未完成工单',
  [ApdmContactBlockReason.WorkingLead]: '正在跟进的商机',
  [ApdmContactBlockReason.UnansweredProactive]: '尚未回复其他触达',
  [ApdmContactBlockReason.AlreadyReached]: '已经触达',
  [ApdmContactBlockReason.RecipientNotDue]: '尚未到触达时间',
  [ApdmContactBlockReason.CustomerReplied]: '客户已回复',
  [ApdmContactBlockReason.StaffPaused]: '员工已暂停',
};

/**
 * Why a campaign message did not go out, by the code the backend records:
 * the RPA task's error code or status, or the campaign's own.
 */
const kApdmFailureReasonLabels: Record<string, string> = {
  contact_not_found: '微信里没有找到这位客户',
  contact_unavailable: '这位客户的微信暂时无法发送',
  account_throttled: '微信账号发送受限，稍后再试',
  client_offline: '发送的电脑不在线',
  task_expired: '当天没来得及发送',
  timeout: '发送超时，没有完成',
  error: '发送时出错',
  execution_failed: '发送时出错',
  cancelled: '发送被取消',
  refused_by_assignee: '负责的电脑没有接下这次发送',
  delivery_unconfirmed: '没能确认是否送达',
  discovery_timeout_unconfirmed: '多次没找到这位客户的微信',
  ended_before_send: '活动结束前没来得及发送',
  ended_delivery_unconfirmed: '活动结束时还没确认是否送达',
  runtime_recovery_blocked: '发送的电脑出了问题，没有完成',
  local_task_state_lost: '发送的电脑出了问题，没有完成',
  partial_success: '只发出了一部分',
  message_read_failed: '发送后没能读到聊天记录',
  message_read_incomplete: '发送后没能读到聊天记录',
};

export function apdmFailureReasonText(code: string | null): string {
  // An unknown code is the machine's side as often as the customer's.
  return (code && kApdmFailureReasonLabels[code]) || '发送没有完成';
}
